module.exports = "https://cdn.dove.it/_next/static/public/assets/channels/logo-facebook.949d9f1568a170f88891af8d3fb1bcf5.png";